import React from 'react'
import StaticContent from '@components/StaticContent'
import cx from 'classnames'
import { adStyles } from './adStyles'

/**
 * 文末推薦模組
 */
export default function PostRecommendations(props) {
  return <StaticContent className={cx('Zi_ad_ar_Rec', props.className)} css={adStyles} />
}
